import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from '../rest-api.service';
import { NotifierService } from 'angular-notifier';
import { MessageService } from '../message.service';
import { ConfigService } from '../config.service';
@Component({
    selector: 'app-login-jusco',
    templateUrl: './login-jusco.component.html',
    styleUrls: ['./login-jusco.component.css']
})
export class LoginJUSCOComponent implements OnInit {
    loginName: string;
    password: string;
    private respObject: any;
    private notifier: NotifierService;
    clientSelected: string;
    clients: any;
    clientId: number;
    encTicketId: any;
    encLoginId: any;
    encCLientId: any;
    map: any;
    isAutoLogin: boolean;

    constructor(private route: Router, private _rest: RestApiService, notifier: NotifierService,
        private messageService: MessageService, private config: ConfigService, private actRoute: ActivatedRoute) {
        this.notifier = notifier;
    }

    ngOnInit() {
        this.map = {};

        // this.messageService.setClientId(1);

        // this._rest.getLoginClientList().subscribe((res) => {
        //     this.respObject = res;

        //     if (this.respObject.success) {

        //         this.clients = this.respObject.clients;

        //         for (let i = 0; i < this.clients.length; i++) {
        //             console.log(" 1 == >>> " + this.clients[i].id);
        //             this.map[this.clients[i].clientCode] = this.clients[i].id;
        //         }
        //         console.log(" == >>> " + this.map);
        //     }
        // }, (err) => {
        // });

        this.loginName = '';

        this.password = '';

        this.isAutoLogin = false;

        if (this.config.type === 'LOCAL') {
            this.clientSelected = 'ITSM';
        } else if (this.config.type === 'UAT') {
            this.clientSelected = 'ITSM';
        } else {
            this.clientSelected = 'TSUISL';
        }
        this.messageService.setClientCode(this.clientSelected);

        this.encTicketId = '';

        this.encLoginId = '';

        this.encCLientId = '';

        this.actRoute.queryParams.subscribe(params => {
            this.encTicketId = params['encTicketId'];

            // this.encLoginId = params['encLoginId'];

            // this.encCLientId = params['encCLientId'];

            console.log(this.encTicketId + ' -- ' + this.encLoginId + ' -- ' + this.encCLientId);

            if (this.encTicketId !== undefined) {

                this.encTicketId = this.messageService.xorEncode(atob(this.encTicketId), this.messageService.SECRET_TOKEN);

                // this.encLoginId = this.messageService.xorEncode(atob(this.encLoginId), this.messageService.SECRET_TOKEN);

                // this.encCLientId = this.messageService.xorEncode(atob(this.encCLientId), this.messageService.SECRET_TOKEN);

                // this.loginName = this.encLoginId;

                this.isAutoLogin = true;
            } else {
                this.messageService.clearSession();
                this.isAutoLogin = false;
            }
        });
    }

    login() {
        const data = {
            loginName: this.loginName,
            clientCode: this.clientSelected,
            password: this.password
        };
        if (!this.messageService.isBlankField(data)) {

            console.log(this.clientSelected.toLowerCase() + " -- " + this.map[this.clientSelected.toLowerCase()]);

            this.messageService.setClientId(this.map[this.clientSelected.toLowerCase()]);

            this._rest.loginlt(data).subscribe((res) => {

                this.respObject = res;

                if (this.respObject.success) {

                    const clientId = this.respObject.details.clientId;

                    const userId = this.respObject.details.id;

                    const encodedId = btoa(this.messageService.xorEncode(userId + '', this.messageService.SECRET_TOKEN));

                    const encodedloginName = btoa(this.messageService.xorEncode(this.loginName + '', this.messageService.SECRET_TOKEN));

                    console.log(typeof clientId, clientId);

                    this.messageService.setClientId(clientId);

                    if (this.isAutoLogin) {
                        window.location.href = this.messageService.API_ROOT + '/#/ticket/TicketSearch?ticket_no=' + this.encTicketId + '&clientId=' +
                            clientId + '&ln=' + encodedloginName + '&token='
                            + this.respObject.details.token + '&type=' + '';
                    } else {
                        if (clientId === 1) {
                            this.messageService.addSessionData(this.respObject.details.id + '', this.respObject.details.token, clientId);
                            this.route.navigate(['admin/module']);
                        } else {
                            window.location.href = this.respObject.details.dashboard
                                + '?userId=' + encodedId + '&token=' + this.respObject.details.token + '&clientId='
                                + clientId;;
                        }
                    }


                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
        }
    }

}
